import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/data/projects_event_logs'
export default {
  namespaced: true,
  state: {
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      data: null,
      component: null,
      item_id: null,
      action: null,
      ip_address: null,
      id_customer_users: null,
      id_users: null,
    },
    filterData: {
      sdate: null,
      edate: null,
      id_projects: null,
      id_licenses: null,
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
    dataLoading: false,
  },
  getters: {
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    filterData(state) {
      return state.filterData
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
    getDataLoading(state) {
      return state.dataLoading
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        data: null,
        component: null,
        item_id: null,
        action: null,
        ip_address: null,
        id_customer_users: null,
        id_users: null,
      }
    },
    RESET_FILTER_DATA(state) {
      state.filterData = {
        sdate: null,
        edate: null,
        id_projects: null,
        id_licenses: null,
      }
    },
    RESET_DATA_LIST(state) {
      state.dataList = []
    },
    SET_DATA_LOADING(state, data) {
      state.dataLoading = data
    },
  },
  actions: {
    getDataList({ commit }, params) {
      commit('RESET_DATA_ITEM')
      commit('SET_DATA_LOADING', true)
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
          commit('SET_DATA_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    getDataItem({ commit }, id) {
      commit('RESET_DATA_ITEM')
      commit('SET_DATA_LOADING', true)
      const data = JSON.stringify({
        where: {
          'event_logs.id': id,
        },
        array: false,
      })
      return axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_ITEM', response.data.data)
          commit('SET_DATA_LOADING', false)
          return response.data.data
        })
        .catch(error => console.error(error))
    },
    saveData({ commit }, postData) {
      const data = JSON.stringify(postData)
      commit('SET_DATA_LOADING', true)
      axiosIns
        .post(`${ROOT_URL}/saveData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_DATA_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    removeData({ commit }, id) {
      commit('SET_DATA_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_DATA_LOADING', false)
          return response.data.status
        })
        .catch(error => console.error(error))
    },
  },
}
